module.exports = __webpack_public_path__ + "img/lisa.a3a559b3.svg";